<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div class="full-page-bg-color" slot="no-body">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img alt="login" class="mx-auto" src="@/assets/images/pages/login.png">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg" ref="login">
              <ValidationObserver mode="lazy" ref="validator" v-slot="{ invalid }">
                <form @submit.prevent="login()">
                  <div class="w-full p-8">
                    <div class="vx-card__title mb-8">
                      <h4 class="mb-4">Login</h4>
                      <p>Welcome, please login to your account.</p>
                    </div>

                    <base-input
                      :label-placeholder="$t('auth.email')"
                      :name="$t('auth.email')"
                      autofocus
                      class="w-full no-icon-border"
                      icon="icon icon-user"
                      icon-pack="feather"
                      rules="required|email"
                      v-model="email"/>

                    <base-input
                      :label-placeholder="$t('auth.password')"
                      :name="$t('auth.password')"
                      class="w-full no-icon-border"
                      icon="icon icon-lock"
                      icon-pack="feather"
                      rules="required"
                      type="password"
                      v-model="password"/>

                    <div class="flex flex-wrap justify-between mt-5">
                      <router-link to="#">Forgot Password?</router-link>
                    </div>
                    <base-button :disabled="invalid" :loading="loading" button="filled"
                                 class="w-full mt-5" type="submit">
                      {{ $t('auth.login') }}
                    </base-button>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import VxCard from "../../components/vx-card/VxCard";
  import BaseButton from "../../components/_base-button";

  export default {
    components: {BaseButton, VxCard},
    data () {
      return {
        email: '',
        password: '',
        loading: false
      }
    },
    methods: {
      async login () {
        const isValid = await this.$refs.validator.validate()
        if (!isValid) return
        this.loading = true
        this.$store.dispatch('login', {email: this.email, password: this.password}).then(async () => {
          await this.$store['dispatch']('me');
          await this.$router.push({name: 'home'});
        }).catch((error) => {
          this.$notificationService.error(error.error)
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>

<style lang="scss">
  #page-login {
    .social-login {
      .bg-facebook {
        background-color: #1551b1;
      }

      .bg-twitter {
        background-color: #00aaff;
      }

      .bg-google {
        background-color: #4285F4;
      }

      .bg-github {
        background-color: #333;
      }
    }
  }
</style>
